import api from '../api';

// Helper function để tạo headers với token
const getAuthHeaders = (token) => ({
  'Authorization': `Bearer ${token}`,
  'Content-Type': 'application/json'
});

// User API functions for admin
export const userApi = {
  // Lấy danh sách tất cả users
  getUsers: async (token, params = {}) => {
    try {
      const url = '/admin/accounts/';
      const response = await api.get(url, {
        headers: getAuthHeaders(token),
        params
      });
      return response;
    } catch (error) {
      console.error('Error getting users:', error);
      throw error;
    }
  },

  // Lấy chi tiết user theo ID
  getUserById: async (token, userId) => {
    try {
      const response = await api.get(`/admin/accounts/${userId}`, {
        headers: getAuthHeaders(token)
      });
      return response;
    } catch (error) {
      console.error('Error getting user by ID:', error);
      throw error;
    }
  },



  // Xóa user


  // Duyệt user
  approveUser: async (token, userId, status, roleId) => {
    try {
      const response = await api.put(`/admin/accounts/${userId}/status-role`, { status, roleId }, {
        headers: getAuthHeaders(token)
      });
      return response;
    } catch (error) {
      console.error('Error approving user:', error);
      throw error;
    }
  },

  

  // Thay đổi role của user
  changeUserRole: async (token, userId, roleid) => {
    try {
      roleid = Number(roleid);
      const response = await api.put(`/admin/accounts/${userId}/role`, { roleId: roleid }, {
        headers: getAuthHeaders(token)
      });
      return response;
    } catch (error) {
      console.error('Error changing user role:', error);
      throw error;
    }
  },

  // Lấy thống kê users
  getUserStats: async (token) => {
    try {
      const response = await api.get('/admin/accounts/stats', {
        headers: getAuthHeaders(token)
      });
      return response;
    } catch (error) {
      console.error('Error getting user stats:', error);
      throw error;
    }
  }
};

export default userApi; 
